import * as sterlingparker from './CompetitionBySportV2.styles.sterlingparker';
import * as volcanobet from './CompetitionBySportV2.styles.volcanobet';
import * as betprofessor from './CompetitionBySportV2.styles.betprofessor';
import * as puntgenie from './CompetitionBySportV2.styles.puntgenie';
import * as junglebet from './CompetitionBySportV2.styles.junglebet';
import * as fiestabet from './CompetitionBySportV2.styles.fiestabet';
import * as puntcity from './CompetitionBySportV2.styles.puntcity';
import * as betgalaxy from './CompetitionBySportV2.styles.betgalaxy';
import * as betroyale from './CompetitionBySportV2.styles.betroyale';
import * as juicybet from './CompetitionBySportV2.styles.juicybet';
import * as goldenrush from './CompetitionBySportV2.styles.goldenrush';
import * as vikingbet from './CompetitionBySportV2.styles.vikingbet';
import * as questbet from './CompetitionBySportV2.styles.questbet';
import * as wellbet from './CompetitionBySportV2.styles.wellbet';
import * as sugarcastle from './CompetitionBySportV2.styles.sugarcastle';
import * as oldgill from './CompetitionBySportV2.styles.oldgill';
import * as buffalobet from './CompetitionBySportV2.styles.buffalobet';
import * as titanbet from './CompetitionBySportV2.styles.titanbet';
import * as gigabet from './CompetitionBySportV2.styles.gigabet';
import * as slambet from './CompetitionBySportV2.styles.slambet';
import * as betstride from './CompetitionBySportV2.styles.betstride';
import * as templebet from './CompetitionBySportV2.styles.templebet';
import * as goldenbet888 from './CompetitionBySportV2.styles.goldenbet888';
import * as hyperbet from './CompetitionBySportV2.styles.hyperbet';
import * as bet777 from './CompetitionBySportV2.styles.bet777';
import * as chromabet from './CompetitionBySportV2.styles.chromabet';
import * as bet575 from './CompetitionBySportV2.styles.bet575';
import * as betblast from './CompetitionBySportV2.styles.betblast';
import * as pyramidbet from './CompetitionBySportV2.styles.pyramidbet';
import * as magnumbet from './CompetitionBySportV2.styles.magnumbet';

import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  sterlingparker,
  volcanobet,
  betprofessor,
  puntgenie,
  junglebet,
  fiestabet,
  puntcity,
  betgalaxy,
  betroyale,
  juicybet,
  goldenrush,
  vikingbet,
  questbet,
  wellbet,
  sugarcastle,
  oldgill,
  buffalobet,
  titanbet,
  gigabet,
  slambet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  betblast,
  pyramidbet,
  magnumbet,
};
